import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./inicio.css";
import nosotrosImg from '../../images/nosotros.jpg';
import doctorImg from '../../images/doctor.jpg';
import "@fortawesome/fontawesome-free/css/all.min.css";

const Inicio = () => {
  const location = useLocation();
  const [text, setText] = useState("");
  const navigate = useNavigate();

  const handlePrevio = () => {
    navigate('/indicaciones/previas');
    window.scrollTo(0, 0);
  };
  
  const handleDia = () => {
    navigate('/indicaciones/dia-cirugia');
    window.scrollTo(0, 0);
  };
  
  const handleRecuperacion = () => {
    navigate('/indicaciones/recuperacion');
    window.scrollTo(0, 0);
  };
  

  useEffect(() => {
    if (location.hash) {
      const section = document.querySelector(location.hash);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const handleSubmit = () => {
    localStorage.setItem("cachedText", text);
    navigate("/preguntas");
  };

  return (
    <div>
      {/* Header */}
      <header className="header">
        <div className="header-overlay"></div>

        {/* Title and Searcher */}
        <main className="main-title">
          <h1>Anestesia explicada para pacientes</h1>
          <div className="searcher">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Resolvemos tus dudas en 1 minuto"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>
          <button id="button" onClick={handleSubmit}>
            Buscar
          </button>
        </main>
      </header>

      {/* Secondary Nav Bar */}
      <section id="indicaciones">
        <div className="secondary-navbar">
          <div className="previo">
            <p>Previo a la Cirugía</p>
            <button id="button" onClick={handlePrevio}>Información</button>
          </div>
          <div className="dia">
            <p>El día de la Cirugía</p>
            <button id="button" onClick={handleDia}>Información</button>
          </div>
          <div className="durante">
            <p>Durante la Recuperación</p>
            <button id="button" onClick={handleRecuperacion}>Información</button>
          </div>
        </div>
      </section>

    <section id="conoce">
      {/* About Us Section */}
      <div className="about_us">
      <img src={nosotrosImg} alt="Nuestro Equipo" className="img-nosotros"/>
        <div className="about-us-content">
          <h2>Nuestro Equipo</h2>
          <p>
          Contamos con un equipo altamente capacitado de anestesiólogos con amplia experiencia en distintas especialidades quirúrgicas. Su compromiso con la seguridad, el confort y el bienestar del paciente es nuestra prioridad en cada procedimiento.
          </p>
        </div>
      </div>
      </section>

      {/* Experience Section */}
      <div className="experience">
        
        <div className="experience-content">
        <h1>Formación</h1>
          <p>
            <a>7  </a> años  &rarr; Medicina General
          </p>
          <p></p>
          <p>
            <a>3</a> años &rarr; Especialidad en Anestesiología
          </p>
          <p>
            <a>1-3</a> años &rarr; Subespecialidad
          </p>
        </div>
        <img src={doctorImg} alt="Nuestro Equipo" />
      </div>

    </div>
  );
};

export default Inicio;
